(()=>{
  if(customElements.get('kiinze-materiales'))return;
  class KiinzeMateriales extends HTMLElement{
    connectedCallback(){
      if(this.dataset.ready==='true')return;
      this.dataset.ready='true';
      this.buttons=[...this.querySelectorAll('[data-km-select]')];
      this.panels=[...this.querySelectorAll('[data-km-panel]')];
      this.titleElement=this.querySelector('[data-km-title]');
      this.textElement=this.querySelector('[data-km-text]');
      this.countElement=this.querySelector('[data-km-count]');
      this.buttons.forEach(button=>button.addEventListener('click',()=>this.select(button)));
    }
    select(button){
      const panel=this.panels.find(item=>item.dataset.kmPanel===button.dataset.kmSelect);
      if(!panel)return;
      const image=panel.querySelector('[data-km-image]');
      if(image&&image.dataset.src){
        image.srcset=image.dataset.srcset||'';
        image.src=image.dataset.src;
        delete image.dataset.src;
        delete image.dataset.srcset;
      }
      this.buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      this.panels.forEach(item=>{item.hidden=item!==panel;});
      if(this.titleElement)this.titleElement.textContent=button.dataset.title||'';
      if(this.textElement)this.textElement.textContent=button.dataset.text||'';
      if(this.countElement)this.countElement.textContent=button.dataset.count||'';
    }
  }
  customElements.define('kiinze-materiales',KiinzeMateriales);
})();
